<template>
  <router-view />
</template>

<script>
export default {
  name: "app-child"
};
</script>

<style lang="scss" scoped></style>
